import { BotOptStatus, CrossPromoStatus, ShortcutStatus } from './UserActions';

/**
 * User state contains session-level data related to the current user. This data is not persisted across play sessions.
 */
export interface IUserState {
    userId: string;
    username: string;
    userAvatar: string;

    subscribeBot: BotOptStatus;
    crossPromo: CrossPromoStatus;
    createShortcut: ShortcutStatus;
}

export const initialUserState: IUserState = {
    subscribeBot: BotOptStatus.DISABLED,
    crossPromo: CrossPromoStatus.DISABLED,
    createShortcut: ShortcutStatus.DISABLED,
    userAvatar: null,
    userId: null,
    username: null,
};
